import { MessageSquareWarning } from "lucide-react";

import { Button } from "@/components/ui/button";

export function NotesButton({
	openCount,
	onClick,
}: {
	openCount: number;
	onClick: () => void;
}) {
	return (
		<Button
			type="button"
			variant="outline"
			size="sm"
			className="notes-button"
			onClick={onClick}
		>
			<MessageSquareWarning />
			Alertas e observações
			{openCount > 0 && (
				<span className="notes-button__badge" data-testid="notes-badge">
					{openCount}
				</span>
			)}
		</Button>
	);
}
